import script from "./VorauswahlStart.vue?vue&type=script&setup=true&lang=js"
export * from "./VorauswahlStart.vue?vue&type=script&setup=true&lang=js"

import "./VorauswahlStart.vue?vue&type=style&index=0&id=30e4a525&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e4a525"]])

export default __exports__